import { useCallback, useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";
import { useSessionTermination } from "./session-termination";

/** Şirket değişimi aynı oturumdur; kimlik veya oturum değişimi ayrı taslak/niyet alanıdır. */
export function useSessionScope(): readonly string[] {
  const { user } = useAuth();
  return [
    String(user?.profile.iss ?? ""),
    String(user?.profile.tenant_id ?? ""),
    user?.profile.sub ?? "",
    String(user?.profile.sid ?? ""),
  ];
}

/** İki yazım arasındaki await, işlemi başka kimliğin bearer'ıyla sürdüremez. */
export function useSessionContinuation(): () => () => boolean {
  const scope = JSON.stringify(useSessionScope());
  const current = useRef(scope);
  current.current = scope;
  const mounted = useRef(true);
  const termination = useSessionTermination();
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  return useCallback(() => {
    const captured = current.current;
    return () => mounted.current && current.current === captured && termination.getSnapshot() === "active";
  }, [termination]);
}
